class FreeShippingBanner extends HTMLElement {
  constructor() {
    super();
  }

  get selectors() {
    return {
      signInButton: "[data-trigger='sign-in']",
      signUpButton: "[data-trigger='sign-up']",
      accountDrawer: "account-drawer"
    }
  }

  get accountDrawerTiers() {
    return {
      signIn: "AccountSignIn",
      signUp: "AccountSignUp"
    }
  }

  connectedCallback() {
    this.signInButton = this.querySelector(this.selectors.signInButton);
    this.signUpButton = this.querySelector(this.selectors.signUpButton);

    if (!this.signInButton || !this.signUpButton) {
      return;
    }

    this.accountDrawer = document.querySelector(this.selectors.accountDrawer);

    this.signInButton.addEventListener("click", (event) => {
      event.preventDefault();

      this.accountDrawer.openDrawerWithTier(this.accountDrawerTiers.signIn);
    });

    this.signUpButton.addEventListener("click", (event) => {
      event.preventDefault();

      this.accountDrawer.openDrawerWithTier(this.accountDrawerTiers.signUp);
    });
  }
}

if (!customElements.get("free-shipping-banner")) {
  customElements.define("free-shipping-banner", FreeShippingBanner);
}
